import { render, staticRenderFns } from "./AiSearch.vue?vue&type=template&id=0cf7f1d8&scoped=true&"
import script from "./AiSearch.vue?vue&type=script&lang=js&"
export * from "./AiSearch.vue?vue&type=script&lang=js&"
import style0 from "./AiSearch.vue?vue&type=style&index=0&id=0cf7f1d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf7f1d8",
  null
  
)

export default component.exports